<template src="./html/productStorages.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Edit from './../views/Edit.vue'
	import draggable from 'vuedraggable'
	import VueElementLoading from 'vue-element-loading'

	export default {
		props: ['user', 'isAuth', 'item', 'type', 'canChangeTax'],
		components: {
			'edit': Edit,
			'loading': VueElementLoading,
			draggable,
		},
		data () {
			return {
				loading: false,
				taxes: null,
				currencies: null,
				statuses: null,

				draggableOptions: {
					handle: '.draggable-arrows',
					scroll: true,
				}
			}
		},
		created() {
			this.init()
		},
		methods: {
			init() {
			},
			reload() {
				this.$emit('reload')
			},
			editProduct(currentProduct) {
				this.$nextTick( () => {
					if(currentProduct.group_parent) {
						var product = this.item.products.find(function(product) {
							return product.id == currentProduct.group_parent.product_storage_id
						})
						if(product) {
							this.$refs.edit.open(product, currentProduct.id)
						} else {
							this.$refs.edit.open(currentProduct)
						}
					} else {
						this.$refs.edit.open(currentProduct)
					}
				})
			},
			destroyProduct(product) {
				var that = this

				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					showCancelButton: true,
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showLoaderOnConfirm: true,
					preConfirm: function () {
						return new Promise(function (resolve) {
							that.$http.delete('admin/management/products/storages/' + product.id)
							.then(response => {
								let index = that.item.products.indexOf(product)
								that.item.products.splice(index, 1)
								that.$emit('reload')
								swal(response.body.title, response.body.text, response.body.type);
							}).catch(function(response) {
								swal({
									title: response.statusText,
									text: response.body,
									type: "warning"
								});
							})
						})
					}
				}]).catch(swal.noop)
			},
			changeQuantity(product) {
				product.quantity = this.toInteger(product.quantity)
				var ref = '#tr-product-' + product.id
				var input = $(event.target)
				var tr = $(ref)

				tr.addClass('disabled')
				input.attr('disabled', true)

				this.inheritQuantity(product)
				this.calculateTotalMeasurementUnitQuantity(product)

				this.calculateTotalTaxes(product)
				this.calculateAmount(product)
				this.calculateTotal(product)
				this.calculateTotalPriceQuantity(product)

				this.calculatePurchaseTotalTaxes(product)
				this.calculatePurchaseAmount(product)
				this.calculatePurchaseTotal(product)
				this.calculatePurchaseTotalPriceQuantity(product)
				this.calculateProfit(product)
				this.updateProduct(product)
			},
			toInteger(value) {
				if(value) {
					if(isNaN(value)) {
						return null
					} else {
						var stringNumber = String(value)
						stringNumber = stringNumber.replace(',', '')
						stringNumber = stringNumber.replace('.', '')
						value = Number(stringNumber)
						return parseInt(value)
					}
				}
				return value
			},

			//-- Quantity change
				calculateTotalMeasurementUnitQuantity(product) {
					if(product.total_measurement_unit) {
						var total_measurement_unit = parseFloat(product.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					if(product.quantity) {
						var quantity = parseInt(product.quantity)
					} else {
						var quantity = 1
					}

					var total_measurement_unit_quantity = total_measurement_unit * quantity
					product.total_measurement_unit_quantity = parseFloat(total_measurement_unit_quantity).toFixed(2)
				},

				//-- SALES
				calculateTotalTaxes(product) {
					if(product.tax) {
						if(product.price) {
							var price = parseFloat(product.price)
						} else {
							var price = 0
						}

						if(product.quantity) {
							var quantity = parseInt(product.quantity)
						} else {
							var quantity = 1
						}

						var total_taxes = price * product.tax.value / 100 * quantity
						product.total_taxes = parseFloat(total_taxes).toFixed(2)
					} else {
						product.total_taxes = 0
					}
				},
				calculateAmount(product) {
					if(product.price) {
						var price = parseFloat(product.price)
					} else {
						var price = 0
					}

					if(product.taxes) {
						var taxes = parseFloat(product.taxes)
					} else {
						var taxes = 0
					}

					var amount = price + taxes

					product.amount = parseFloat(amount).toFixed(2)
				},
				calculateTotal(product) {
					if(product.amount) {
						var amount = parseFloat(product.amount)
					} else {
						var amount = 0
					}

					if(product.total_measurement_unit) {
						var total_measurement_unit = parseFloat(product.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					var total = total_measurement_unit * amount

					if(product.extras) {
						if(product.extras.length) {
							product.extras.forEach(function(extra) {
								if(extra.sale_value) {
									total =  total + parseFloat(extra.sale_value)
								}
							})
						}
					}
					
					product.total = parseFloat(total).toFixed(2)
				},
				calculateTotalPriceQuantity(product) {
					if(product.total) {
						var total = parseFloat(product.total)
					} else {
						var total = 0
					}

					if(product.quantity) {
						var quantity = parseInt(product.quantity)
					} else {
						var quantity = 1
					}

					var total_price_quantity = total * quantity
					product.total_price_quantity = parseFloat(total_price_quantity).toFixed(2)
				},

				//-- Purchase
				calculatePurchaseTotalTaxes(product) {
					if(product.tax) {
						if(product.purchase_price) {
							var purchase_price = parseFloat(product.purchase_price)
						} else {
							var purchase_price = 0
						}

						if(product.quantity) {
							var quantity = parseInt(product.quantity)
						} else {
							var quantity = 1
						}
						
						var purchase_total_taxes = purchase_price * product.tax.value / 100 * quantity
						product.purchase_total_taxes = parseFloat(purchase_total_taxes).toFixed(2)
					} else {
						product.purchase_total_taxes = 0
					}
				},
				calculatePurchaseAmount(product) {
					if(product.purchase_price) {
						var purchase_price = parseFloat(product.purchase_price)
					} else {
						var purchase_price = 0
					}

					if(product.purchase_taxes) {
						var purchase_taxes = parseFloat(product.purchase_taxes)
					} else {
						var purchase_taxes = 0
					}

					var purchase_amount = purchase_price + purchase_taxes

					product.purchase_amount = parseFloat(purchase_amount).toFixed(2)
				},
				calculatePurchaseTotal(product) {
					if(product.purchase_amount) {
						var purchase_amount = parseFloat(product.purchase_amount)
					} else {
						var purchase_amount = 0
					}

					if(product.total_measurement_unit) {
						var total_measurement_unit = parseFloat(product.total_measurement_unit)
					} else {
						var total_measurement_unit = 1
					}

					var purchase_total = purchase_amount * total_measurement_unit

					if(product.extras) {
						if(product.extras.length) {
							product.extras.forEach(function(extra) {
								if(extra.purchase_value) {
									purchase_total =  purchase_total + parseFloat(extra.purchase_value)
								}
							})
						}
					}

					product.purchase_total = parseFloat(purchase_total).toFixed(2)
				},
				calculatePurchaseTotalPriceQuantity(product) {
					if(product.purchase_total) {
						var purchase_total = parseFloat(product.purchase_total)
					} else {
						var purchase_total = 0
					}

					if(product.quantity) {
						var quantity = parseInt(product.quantity)
					} else {
						var quantity = 1
					}

					var purchase_total_price_quantity = purchase_total * quantity
					product.purchase_total_price_quantity = parseFloat(purchase_total_price_quantity).toFixed(2)
				},
			//-- Quantity change
			updateProduct (product) {
				this.$http.put('admin/management/products/storages/' + product.id, product)
				.then(response => {
					this.$emit('reload')
				}).catch(function(response) {
					this.$emit('reload')
					console.log(response)
				})
			},
			inheritQuantity(product) {
				var that = this
				if(product) {
					if(product.products) {
						if(product.products.length) {
							product.products.forEach(function(element) {
								element.quantity = product.quantity

								that.calculateTotalMeasurementUnitQuantity(element)
								that.calculateTotalTaxes(element)
								that.calculateAmount(element)
								that.calculateTotal(element)
								that.calculateTotalPriceQuantity(element)

								that.calculatePurchaseTotalTaxes(element)
								that.calculatePurchaseAmount(element)
								that.calculatePurchaseTotal(element)
								that.calculatePurchaseTotalPriceQuantity(element)
							})
						}
					}
				}
			},
			calculateProfit(product) {
				this.calculateValue(product)
				this.calculatePercent(product)
				this.calculateValueMeasurementUnit(product)
			},
				calculateValue(product) {
					var purchase_price = 0
					if(product.purchase_price) {
						purchase_price = parseFloat(product.purchase_price).toFixed(2)
					}

					var price = 0
					if(product.price) {
						price = parseFloat(product.price).toFixed(2)
					}

					var profit_value = parseFloat(price - purchase_price).toFixed(2)
					product.profit_value = profit_value
				},
				calculatePercent(product) {
					var purchase_price = 0
					if(product.purchase_price) {
						purchase_price = parseFloat(product.purchase_price).toFixed(2)
					}

					var price = 0
					if(product.price) {
						price = parseFloat(product.price).toFixed(2)
					}

					var profit_value = 0
					if(product.profit_value) {
						profit_value = parseFloat(product.profit_value).toFixed(2)
					}

					if(purchase_price > 0) {
						var profit_percent = profit_value * 100
						if(profit_percent == 0) {
							profit_percent = 0
						} else {
							profit_percent = profit_percent / purchase_price
						}
					} else {
						if(price > 0) {
							var profit_percent = 100
						} else {
							var profit_percent = 0
						}
					}

					product.profit_percent = parseFloat(profit_percent).toFixed(2)
				},
				calculateValueMeasurementUnit(product) {
					var profit_value = 0
					if(product.profit_value) {
						profit_value = product.profit_value
					}

					var total_measurement_unit = 1
					if(product.total_measurement_unit) {
						total_measurement_unit = product.total_measurement_unit
					}

					var quantity = 1
					if(product.quantity) {
						quantity = product.quantity
					}

					var profit_val_measurement_unit = profit_value * total_measurement_unit * quantity
					product.profit_val_measurement_unit = parseFloat(profit_val_measurement_unit).toFixed(2)
				},

			changeSort(data) {
				this.loading = true
				var moved = data.moved

				var product_1 = this.item.products[moved.newIndex]
				var product_2 = this.item.products[moved.oldIndex]

				var move = null
				if(moved.newIndex > moved.oldIndex) {
					move = 'down'
				} else {
					if(moved.newIndex < moved.oldIndex) {
						move = 'up'
					}
				}

				var product = null

				if(move == 'down') {
					var product = this.item.products[moved.newIndex - 1]
					this.$http.get('admin/management/products/storages/' + moved.element.id + '/sort/after/' + product.id)
						.then(response => {
							this.$emit('reload')
							this.loading = false
						}).catch(function(response) {
							console.log(response)
							this.loading = false
						})
				} else {
					if(move == 'up') {
						var product = this.item.products[moved.newIndex + 1]
						this.$http.get('admin/management/products/storages/' + moved.element.id + '/sort/before/' + product.id)
							.then(response => {
								this.$emit('reload')
								this.loading = false
							}).catch(function(response) {
								console.log(response)
								this.loading = false
							})
					}
				}
			},

			//--
			calculateSave(product) {
				if(product.base_price) {
					var base_price = parseFloat(product.base_price)
				} else {
					var base_price = 0
				}

				if(product.discount) {
					var discount = parseFloat(product.discount)
				} else {
					var discount = 0
				}

				var total = Math.abs(base_price * discount / 100)

				product.save = parseFloat(total).toFixed(2)
			},
			calculatePrice(product) {
				if(product.base_price) {
					var base_price = parseFloat(product.base_price)
				} else {
					var base_price = 0
				}

				if(product.save) {
					var save = parseFloat(product.save)
				} else {
					var save = 0
				}

				var price = base_price - Math.abs(save)

				product.price = parseFloat(price).toFixed(2)
			},
			calculateTaxes(product) {
				if(product.tax) {
					if(product.price) {
						var price = parseFloat(product.price)
					} else {
						var price = 0
					}

					var taxes = price * product.tax.value / 100
					product.taxes = parseFloat(taxes).toFixed(2)
				} else {
					product.taxes = 0
				}
			},
			calculateTotalTaxes(product) {
				if(product.tax) {
					if(product.price) {
						var price = parseFloat(product.price)
					} else {
						var price = 0
					}

					if(product.total_measurement_unit_quantity) {
						var total_measurement_unit_quantity = parseFloat(product.total_measurement_unit_quantity).toFixed(2)
					} else {
						var total_measurement_unit_quantity = 1
					}

					var total_taxes = (price * product.tax.value / 100) * total_measurement_unit_quantity
					product.total_taxes = parseFloat(total_taxes).toFixed(2)
				} else {
					product.total_taxes = 0
				}
			},
			calculateAmount(product) {
				if(product.price) {
					var price = parseFloat(product.price)
				} else {
					var price = 0
				}

				if(product.taxes) {
					var taxes = parseFloat(product.taxes)
				} else {
					var taxes = 0
				}

				var amount = price + taxes

				product.amount = parseFloat(amount).toFixed(2)
			},
			calculateTotal(product) {
				if(product.amount) {
					var amount = parseFloat(product.amount)
				} else {
					var amount = 0
				}

				if(product.total_measurement_unit) {
					var total_measurement_unit = parseFloat(product.total_measurement_unit)
				} else {
					var total_measurement_unit = 1
				}

				var total = total_measurement_unit * amount

				if(product.extras) {
					if(product.extras.length) {
						product.extras.forEach(function(extra) {
							if(extra.sale_value) {
								total =  total + parseFloat(extra.sale_value)
							}
						})
					}
				}
				
				product.total = parseFloat(total).toFixed(2)
			},
			calculateTotalPriceQuantity(product) {
				if(product.total) {
					var total = parseFloat(product.total)
				} else {
					var total = 0
				}

				if(product.quantity) {
					var quantity = parseInt(product.quantity)
				} else {
					var quantity = 1
				}

				var total_price_quantity = total * quantity
				product.total_price_quantity = parseFloat(total_price_quantity).toFixed(2)
			},
			changeDiscount(product) {
				var ref = '#tr-product-' + product.id
				var input = $(event.target)
				var tr = $(ref)

				tr.addClass('disabled')
				input.attr('disabled', true)

				this.updateProduct(product)
			},
			changedDiscount(product) {
				this.calculateSave(product)
				this.calculatePrice(product)
				this.calculateTaxes(product)
				this.calculateTotalTaxes(product)
				this.calculateAmount(product)
				this.calculateTotal(product)
				this.calculateTotalPriceQuantity(product)
				this.calculateProfit(product)
				this.$emit('recalculate')
				//--
				//this.updateProduct(product)
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/layout/productStorages.vue